export function splitWhere<T>(sorted: readonly T[], startsNew: (previous: T, current: T) => boolean): readonly (readonly T[])[] {
  const groups: T[][] = [];
  sorted.forEach((item, i) => {
    if (i === 0 || startsNew(sorted[i - 1]!, item)) groups.push([]);
    groups.at(-1)!.push(item);
  });
  return groups;
}
